
export const isLocal = window.location.hostname.includes('localhost');
export const isDev = window.location.hostname.includes('-dev');

export const TOKEN_KEY = "jwt_token";
export const USER_KEY = "auth_user";
export const EXPIRY_KEY = "jwt_expiry"; // epoch ms when token expires
export const SWIPE_THRESHOLD = 60;
export const GOOGLE_CLIENT_ID = "1075602618164-b6smv398cg3e85q8n0rtci72ts965e1k.apps.googleusercontent.com";
 
export const WRS_START_DB            = 60;    // WRS test – starting dB level (ascending phase)
export const WRS_RESPONSE_TIMEOUT_MS = 6000;  // ms to wait for patient response before auto-advance
export const WRS_WORDS_PER_LEVEL     = 6;    // number of words presented at each dB level during WRS test
export const WRS_EARLY_STOP_AFTER    = 4;     // skip dB level after this many words with 0 correct
export const WRS_WORDS_PER_LEVEL_EXT     = 10;    
export const WRS_EARLY_STOP_AFTER_EXT    = 6;     


export const SRT_RESPONSE_TIMEOUT_MS = 6000;  // ms to wait for patient response after word is spoken
export const SRT_WORDS_PER_LEVEL     = 6;     // words presented at each dB level during SRT test

export const TONAL_SIGNALS_PER_LEVEL = 5;  // liczba sygnałów emitowanych na każdy próg głośności

// Instrukcja każe teraz ustawiać słuchawki na 50% zamiast dawnych 10-15% (~4x głośniej),
// więc generowane sygnały są o tyle samo ciszej, aby faktyczny poziom dB pozostał bez zmian.
export const HEADPHONE_VOLUME_COMPENSATION = 0.25;

export const DESKTOP_BREAKPOINT = 992;
export const PANEL_TRANSITION_MS = 420;

export const copyIcon = "📋";
export const openFolderIcon = "📂";
export const moveToIcon = "➡️";
export const flashCard = "🤓";  
export const mucisIcon = "🎵";
export const musicIcons = "🎶";
export const settingsIcon = "⚙️";
export const changePasswordIcon = "🔒";
export const logoutIcon = "🔚";
export const notebookIcon = "📝";
export const exampleIcon = "♻️";
export const openaiIcon = "✨";
export const messageIcon = "📬";
export const historyIcon = "📉";
export const userActivityIcon = "📊";

export const saveIcon = "💾";
export const analiseIcon = "👁️";
export const editIcon = "✏️";
export const approveIcon = "✅";
export const rejectIcon = "🚫";
export const infoIcon = "ℹ️";
export const warningIcon = "⚡";
export const errorIcon = "🛑";
export const userIcon = "🧑";
export const cancelIcon = "❌";
export const sendIcon = "📤";
export const okIcon = "✔️";
export const addIcon = "➕";
export const printIcon = "🖨️";
export const deleteIcon = "🗑️";
export const newIcon = "📄";
export const changeIcon = "🖌️";
export const closeIcon = "🔒";
export const speakIcon = "📢";

//🛠️🔧🧩✨♻️🪄☄️⚡🔮💎🌠✧✦🔯💫🌟⭐
//❌ 🚫 ⛔ ⚠️ ❗ ❕ 🙅‍♂️ 🙅‍♀️ 🛑👩‍⚖️
//🔍 🔎 🧐 👁️ 👁️‍🗨️ 🧠 🔊
//💬 🗨️ 📨 ✉️ 📞 🔔 🛎️ 📣 📢
//📊 📈 📉 📋 📌 📍 🧮 📅 📆
//📎 📌 🔗 🧭 🗺️ 🎛️ 🎚️ 🪙 🧿 🧲
//📥 📤 ⬇️ ⬆️ 💾 📨 📦 📬 📭 ➡️
//🗑️ ❌ ⛔ 🚫 🔥 🧹 ✂️ 🔒
//✅ ☑️ ✔️ 🆗 👍 🙌 🏁 🎯
//🔄 🔃 🔁 🔀 🔂 🔽 🔼 ↕️ ⬆️ ⬇️ ↩️ ↪️
//💾 📂 📁 🗂️ 📄 📃 📜 📰 🗃️ 📇
//🎨 🖌️ 🧵 ✂️ 🧷 🖼️ 📐 📏 🧲 🖍️
//🧑‍💻 👨‍💻 👩‍💻 🖥️ 💻 📟 🧮 🗂️ 🧾
//⚙️ 🔧 🪛 🧰 🧱 🧲 🧪 🛠️ 🧿 🪙
//✏️ 📝 🖊️ 🖋️ 🪶 🖌️ 🧾 📄 📋 📌 📎
//🧑👨👮👶🧓🧔👥👤 🖨️
//["🎵", "🎶", "🎼", "🎤", "🎧", "🎷", "🎸", "🥁", "🎹"];